const initialState = [];

export default function action(state = initialState, action) {

    let newState = Object.values(naiveShallowCopy(state));

    switch (action.type) {

        case "FB_ADD_GROUP":

            newState.push(action.payload);

            return newState;
        case "FB_SET_GROUPS":

            return action.payload;
        case "FB_REMOVE_GROUP":

            newState = newState.filter(item => {
                return item.id !== action.payload.id;
            });

            return newState;
        case "FB_CHANGE_GROUP":

            const index = newState.findIndex(element => {
                return element.id === action.payload.id
            });

            newState[index] = action.payload;

            return newState;
        case "FB_CLEAR_GROUPS":
            return [];
        default:
            return state;
    }
}

/**
 * This function will copy object without any reference
 * so in our case, redux will detect change, since it does not
 * detect changes in nested objects, like our data is
 *
 * @param original
 * @returns {{}}
 */
function naiveShallowCopy(original) {
    let clone = {};
    let key;
    for (key in original) {
        clone[key] = original[key];
    }
    return clone;
}


// WEBPACK FOOTER //
// ./src/redux/reducers/form-builder/groups.js